import store from "../store/index";
import { ROUTES } from "../helpers/constants";

async function checkAuthRequired(from, to, next) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let { success } = await store.dispatch("users/checkUserSession");

    if (!success) {
      store.commit("users/setUser", { user: null });
      return next({
        name: ROUTES.DIGITAL_EVENT_AUTH_LOGIN
      });
    }
  }
  return next();
}

export { checkAuthRequired };
